// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__QbZFo","row":"Node_row__1d1zA","label":"Node_label__2cLyi","footer":"Node_footer__1R7Fz"};